var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footnotes"},[_c('p',[_vm._v("\n    Die Verbrauchsdaten sollten mit vielfältigen Quellen auf Plausibilität\n    geprüft werden.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Die Kosten für das Heizöl wurden mit tagesaktuellen Preisen berechnet.\n    Abweichungen können entstehen.\n  ")])])
}]

export { render, staticRenderFns }